import Dotdotdot from 'dotdotdot-js'

const DOTDOTDOT_SELECTORS = [
  '.dotdotdot p',
  'p.dotdotdot',
  'h3.dotdotdot',
  'h6.dotdotdot'
]

function createOrUpdateDots (root) {
  const opts = { truncate: 'letter' }

  DOTDOTDOT_SELECTORS.forEach(sel => {
    root.querySelectorAll(sel).forEach(el => {
      // drop old instance if present
      if (el.__dotdotdotInstance?.destroy) {
        el.__dotdotdotInstance.destroy()
      }
      // create new instance
      el.__dotdotdotInstance = new Dotdotdot(el, opts)
    })
  })
}

function gotoOnClick (el) {
  if (el.dataset.href) {
    el.addEventListener('click', () => {
      window.location = el.dataset.href
    })
  }
}

function init () {
  const teasers = Array.from(document.querySelectorAll('.news-teaser'))
  const hasAHolders = document.querySelectorAll('.js-a-holder').length > 0

  teasers.forEach(createOrUpdateDots)
  if (hasAHolders) handleAHolder()

  let resizeTimer
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer)
    resizeTimer = setTimeout(() => {
      teasers.forEach(createOrUpdateDots)
    }, 500)
  })
}

function handleAHolder () {
  if (!document.querySelector('#news-overview-page')) {
    document.querySelectorAll('.js-a-holder').forEach(gotoOnClick)
  }
  document.querySelectorAll('.flyout-container .js-a-holder').forEach(gotoOnClick)
}

export default { init }
export { createOrUpdateDots as setDotdotdot }
